/**
 * APL-11850 (accessibility-modal rework, dev decision 2026-08) — who sees the
 * Display/accessibility settings entry points (UserMenu item + take-rail tool).
 * Staff roles (teacher/admin/qb_author/invigilator/collaborator/support/…) are
 * always entitled; STUDENTS and PARENTS need the org's accessibility_settings
 * feature; an unknown role (currentUser not yet loaded / logged out) is NOT
 * entitled — hidden until the role is known, so there is no pre-load flash.
 * The teacher-preview rail bypasses this at the callsite (teacher surface).
 */
const FLAG_GATED_ROLES: readonly string[] = ['student', 'parent'];

export const displaySettingsAllowed = (
  role: string | null | undefined,
  enabledFeatures: { accessibility_settings?: boolean } | null | undefined
): boolean => {
  if (!role) return false;
  if (FLAG_GATED_ROLES.includes(role)) return !!enabledFeatures?.accessibility_settings;
  return true;
};
